import React, { FC } from 'react';

const offices = [
  {
    id: 1,
    city: 'Maricopa, AZ',
  },
  {
    id: 2,
    city: 'Casa Grande, AZ',
  },
  {
    id: 3,
    city: 'Chandler, AZ',
  },
  { id: 4, city: 'Tempe, AZ' },
];

const ServiceArea: FC = () => (
  <section aria-labelledby="areas-served-heading">
    <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
      <h2
        id="areas-served-heading"
        className="text-3xl font-extrabold text-stone-900"
      >
        Areas we serve!
      </h2>
      <p className="mt-6 text-lg text-stone-500 max-w-3xl">
        HLB Electric serves the Pinal County area as well as the Phoenix
        Metropolitan areas!
      </p>
      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2">
        {offices.map((office) => (
          <div key={office.id}>
            <h3 className="text-lg font-medium text-stone-900">
              {office.city}
            </h3>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServiceArea;
